import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SystemNotificationEdit from './SystemNotificationEdit';

const SystemNotificationEditModal = ({ showNotificationModal, setShowNotificationModal, editProps }) => {
  const close = () => setShowNotificationModal(false);
  return (
    <Modal
      show={showNotificationModal}
      animation={false}
      onHide={close}
      backdrop="static"
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <SystemNotificationEdit {...editProps} />
    </Modal>
  );
};

SystemNotificationEditModal.propTypes = {
  showNotificationModal: PropTypes.bool,
  setShowNotificationModal: PropTypes.func,
  editProps: PropTypes.any,
};

export default SystemNotificationEditModal;
